import * as React from 'react';
import FormRow from '../../../../../components/FormRow';
import FormSection from '../../../../../components/FormSection';
import InputHandler from '../../../../../components/InputHandler';
import { isNil } from 'Utility/ramdaReplacement';

const DMDform = ({ editing, formData }: IOwnProps): React.JSX.Element => {
  return (
    <React.Fragment>
      <FormRow title="diagnosis.symptomOnsetDate" headerWidth={4}>
        <InputHandler
          type="PartialDate"
          editing={!!editing}
          name="symptomOnsetDate"
          formData={formData}
          dateDefault="now"
        />
      </FormRow>
      <FormSection header="diagnosis.dmd">
        <FormRow title="diagnosis.dmdGeneticConfirmation" id={'geneticConfirmation'} headerWidth={4}>
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="dmdGeneticConfirmation"
            formData={formData}
            preset="yesno"
            dependentFieldsList={(): string[] => [
              'dmdMutationName',
              'dmdDeletionOfExons',
              'dmdDuplicationOfExons',
              'dmdBoundariesKnown',
              'dmdExonsSequenced',
              'dmdExonsTestedInMaleRelative',
            ]}
            dependentFieldsRemovalWarning={true}
          />
        </FormRow>
        {(formData.document as IDiagnosis).dmdGeneticConfirmation === true ? (
          <React.Fragment>
            <FormRow title="diagnosis.dmdMutationName" headerWidth={4}>
              <InputHandler
                type="TextField"
                editing={!!editing}
                name="dmdMutationName"
                formData={{
                  onChange: (values: TOnChangeValues): void => {
                    if ((values['dmdMutationName'] as string)?.substring(0, 2) !== 'c.') return;
                    formData.onChange?.(values);
                  },
                  document: {
                    dmdMutationName: isNil(formData.document.dmdMutationName)
                      ? 'c.'
                      : formData.document.dmdMutationName,
                  },
                }}
                minCaretSelection={2}
              />
            </FormRow>
            <FormRow title="diagnosis.dmdDeletionOfExons" id={'exonsDeletion'} headerWidth={4}>
              <InputHandler
                type="Radio"
                editing={!!editing}
                name="dmdDeletionOfExons"
                formData={formData}
                preset="yesNoUnknownForceEn"
              />
            </FormRow>
            <FormRow title="diagnosis.dmdDuplicationOfExons" id={'exonsDuplication'} headerWidth={4}>
              <InputHandler
                type="Radio"
                editing={!!editing}
                name="dmdDuplicationOfExons"
                formData={formData}
                preset="yesNoUnknownForceEn"
              />
            </FormRow>
            <FormRow title="diagnosis.dmdBoundariesKnown" id={'dmdBoundaries'} headerWidth={4}>
              <InputHandler
                type="Radio"
                editing={!!editing}
                name="dmdBoundariesKnown"
                formData={formData}
                preset="yesNoUnknownForceEn"
              />
            </FormRow>
            <FormRow title="diagnosis.dmdExonsSequenced" id={'exonsSequenced'} headerWidth={4}>
              <InputHandler
                type="Radio"
                editing={!!editing}
                name="dmdExonsSequenced"
                formData={formData}
                preset="yesNoUnknownForceEn"
              />
            </FormRow>
            <FormRow title="diagnosis.dmdExonsTestedInMaleRelative" id={'exonsTestedMaleRelative'} headerWidth={4}>
              <InputHandler
                type="Radio"
                editing={!!editing}
                name="dmdExonsTestedInMaleRelative"
                formData={formData}
                preset="yesNoUnknownForceEn"
              />
            </FormRow>
          </React.Fragment>
        ) : undefined}
      </FormSection>
    </React.Fragment>
  );
};

interface IOwnProps {
  editing?: string;
  formData: IFormData<IDiagnosis>;
}

export default DMDform;
